import { render, staticRenderFns } from "./MenuReportVisit.vue?vue&type=template&id=460594cc&scoped=true&"
import script from "./MenuReportVisit.vue?vue&type=script&lang=js&"
export * from "./MenuReportVisit.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportVisit.vue?vue&type=style&index=0&id=460594cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460594cc",
  null
  
)

export default component.exports